import { DiscountMessage } from "Components/DiscountMessage/DiscountMessage";
import { FormikProps } from "formik";
import React from "react";
import { AdvicePriceFormValues } from "../AdviceCards/interfaces";
import { useIsAdvicePriceLoading } from "../hooks/stateSelectors";
import { useTotalPrice } from "../hooks/useTotalPrice";

interface Props {
  formProps: FormikProps<AdvicePriceFormValues>;
}

export const AdviceTotalPriceCard = ({
  formProps,
}: Props): React.ReactElement => {
  const isLoading = useIsAdvicePriceLoading();
  const totalPrice = useTotalPrice(formProps.values);

  const insuranceCount = [
    formProps.values.disabilityCheckedToPurchase,
    formProps.values.deathCheckedToPurchase,
    formProps.values.criticalIllnessCheckedToPurchase,
  ].reduce((acc, value) => acc + Number(value), 0);

  return (
    <div className="AdviceTotalPriceCard">
      <DiscountMessage
        insuranceCount={insuranceCount}
        totalPriceValue={totalPrice}
        isLoading={isLoading}
      />
    </div>
  );
};
